import React, { useState } from 'react';
import { Box, Button, Typography, Alert, Container, Card, CardContent } from '@mui/material';
import axios from '../api/axios';
import { useAuth } from '../contexts/AuthContext';

export const TestAuth: React.FC = () => {
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const { token, user } = useAuth();

  const testAuth = async () => {
    try {
      setError(null);
      console.log('Testing auth with token:', token?.substring(0, 20) + '...');
      const response = await axios.get('/auth/test');
      console.log('Test response:', response.data);
      setResult(response.data);
    } catch (err: any) {
      console.error('Test error:', err);
      setError(err.response?.data?.message || err.message);
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4 }}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Authentication Test
            </Typography>

            <Box sx={{ my: 2 }}>
              <Typography variant="body2">
                <strong>Token in Context:</strong> {token ? 'Yes' : 'No'}
              </Typography>
              <Typography variant="body2">
                <strong>Token in localStorage:</strong> {localStorage.getItem('token') ? 'Yes' : 'No'}
              </Typography>
              <Typography variant="body2">
                <strong>User in Context:</strong> {user ? `${user.firstName} ${user.lastName}` : 'No'}
              </Typography>
            </Box>

            <Button variant="contained" onClick={testAuth} sx={{ mt: 2 }}>
              Test Protected Endpoint
            </Button>

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}

            {result && (
              <Alert severity="success" sx={{ mt: 2 }}>
                <Typography variant="body2">
                  <strong>Message:</strong> {result.message}
                </Typography>
                <Typography variant="body2">
                  <strong>User ID:</strong> {result.user?.id}
                </Typography>
                <Typography variant="body2">
                  <strong>Email:</strong> {result.user?.email}
                </Typography>
              </Alert>
            )}
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};
